import React from 'react'

import CoursesList from '../Data/Cours.json'
import { H2Courses } from '../common/H2/H2'
import {
	SectionCard,
	DivCard,
	CardGrid,
	CardGridli,
	Card,
	CardDiv,
	H3Card,
	CardMeta,
} from '../common/Card/Card'


function Courses() {
	return (

		<SectionCard id="courses">
			<DivCard>
				<H2Courses>Cours</H2Courses>

				<CardGrid>
					{CoursesList.map((content, i) => (
						<CardGridli key={content?.id}>
							<Card>
								<CardDiv>
									<H3Card>
										{
											content?.id === 99 ?
											<a href="#planning"> <i style={{ color:"red" }}> {content?.Name}</i></a> :
											<a href="#planning">{content?.Name}</a>
										}
									</H3Card>
									<CardMeta>
										{content?.Details}
										</CardMeta>
								</CardDiv>
							</Card>
						</CardGridli>
					))}
				</CardGrid>
			</DivCard>
		</SectionCard>

	)
}
export default Courses
